import request from '@/utils/request';

// 获取会员账户详细信息
export function login(data) {
  return request({
    url: '/auth/front/login',
    method: 'post',
    data
  });
}

// 获取会员账户详细信息
export function getAccountListInfo(params) {
  return request({
    url: '/system/front/account/listInfo',
    method: 'get',
    params
  });
}

// 获取校区列表
export function getCampusList(params) {
  return request({
    url: '/system/front/campus/list',
    method: 'get',
    params
  });
}

// 前台海亮学生列表
export function hlStudentList(params) {
  return request({
    url: '/system/front/hlStudent/hlStudentList',
    method: 'get',
    params
  });
}
// 前台海亮学生列表
export function studentList(params) {
  return request({
    url: '/system/front/student/list',
    method: 'get',
    params
  });
}
// 设置为默认学生
export function updateCheckedStudent(params) {
  return request({
    url: `/system/front/student/updateCheckedStudent/${params}`,
    method: 'get'
  });
}
// 获取学生信息
export function getStudentInfo(params) {
  return request({
    url: `/system/front/student/getInfo/${params}`,
    method: 'get'
  });
}
// 修改学生信息
export function updateStudentInfo(data) {
  return request({
    url: '/system/front/student',
    method: 'put',
    data
  });
}
// 新增学生信息
export function addStudentInfo(data) {
  return request({
    url: '/system/front/student/add',
    method: 'post',
    data
  });
}
// 新增海亮学生短信验证
export function smsCodeStudent(data) {
  return request({
    url: `/system/front/hlStudent/smsCodeStudent/${data}`,
    method: 'get'
  });
}
// 检测 新增海亮学生认证返回一个海亮学生列表
export function smsCodeCheckStudent(data) {
  return request({
    url: '/system/front/hlStudent/smsCodeStudent',
    method: 'post',
    data
  });
}
// 获取年级列表
export function getGradeList(data) {
  return request({
    url: `/system/front/teacher/gradeList`,
    method: 'get'
  });
}
// 注册后海亮学生绑定确认信息
export function confirmInfo(data) {
  return request({
    url: `/system/front/hlStudent/confirmInfo`,
    method: 'get'
  });
}
// 认证绑定或覆盖海亮学生
export function addHlStudent(data) {
  return request({
    url: `/system/front/hlStudent/addStudent`,
    method: 'post',
    data
  });
}
// 更改头像
export function updateAvatar(data) {
  return request({
    url: '/file/upload',
    method: 'post',
    data: data
  });
}

// 地址数据
export function getAreaList() {
  return request({
    url: '/system/front/address/get4City',
    method: 'get'
  });
}

// 用户默认信息
export function getDefaultUser() {
  return request({
    url: '/system/front/student/defaultInfo',
    method: 'get'
  });
}

// 获取协议内容
export function getProtocolDetails(id, type) {
  return request({
    url: `/system/front/protocol/${id}/${type}`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/mine.js